import React from 'react';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { Button, Collapse, Tabs, Tab } from 'react-bootstrap';
import NewTaskForm from './NewTaskForm';
import ExistingTaskForm from './ExistingTaskForm';
import ValuePropositionToolbar from './ValuePropositionToolbar';
import Loading from '../common_components/Loading';

@injectIntl
@inject('tasksStore', 'authorizationsStore')
@observer
export default class TasksToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCollapse: false,
    };
  }

  render() {
    const { intl, feedbackChain, tasksStore, authorizationsStore } = this.props;
    const title = (
      <span className="bold">
        <i className="fa fa-th-list" />
        &nbsp;{intl.formatMessage({ id: 'tasks_toolbar_title' })}
      </span>
    );
    if (!feedbackChain.cardId) {
      return (
        <div className="tasks-toolbar">
          {title}
          {!this.state.showCollapse && (
            <div>
              <Button
                block
                onClick={this.toggleCollapse}
                disabled={!authorizationsStore.canCreateTask()}
              >
                {intl.formatMessage({ id: 'add_task_btn' })}
              </Button>
              <br />
            </div>
          )}

          {this.state.showCollapse && (
            <TasksCollapse
              feedbackChain={feedbackChain}
              handleTasksSelect={this.handleTasksSelect}
              handleTasksCancel={this.handleTasksCancel}
              showCollapse={this.state.showCollapse}
            />
          )}
        </div>
      );
    }
    return (
      <div>
        {title}
        <div>
          {intl.formatMessage({ id: 'see_tasks_message' })} &nbsp;
          <a href={feedbackChain.cardLink} target="_blank">
            {intl.formatMessage({ id: 'see_task_link' })}
          </a>
        </div>
        <div>
          <a href="#" onClick={this.handleRemoveTask}>
            {intl.formatMessage({ id: 'unbind_task' })}
          </a>
        </div>
      </div>
    );
  }

  toggleCollapse = () => {
    this.setState({
      showCollapse: !this.state.showCollapse,
    });
  };

  handleTasksCancel = () => {
    this.setState({
      showCollapse: false,
    });
  };

  handleTasksSelect = k => {};

  handleRemoveTask = e => {
    e.preventDefault();
    this.props.feedbackChain.setCardId(null);
    this.setState({
      showCollapse: false,
    });
  };
}

@injectIntl
@inject('valuePropositionsStore')
@observer
class TasksCollapse extends React.Component {
  render() {
    const { intl, feedbackChain } = this.props;
    const valueProposition = this.props.valuePropositionsStore.getById(
      feedbackChain.valuePropositionId,
    );
    let collapseChild;

    if (valueProposition) {
      collapseChild = (
        <div>
          <div className="small text-muted">
            {intl.formatMessage({ id: 'select_value_proposition_warning' })}
            <hr />
          </div>
          <ValuePropositionToolbar feedbackChain={feedbackChain} />
          <br />
          <Tabs
            defaultActiveKey={'new'}
            id="uncontrolled-tab-example"
            className={'tasks-tabs'}
            onSelect={this.props.handleTasksSelect}
          >
            <Tab
              eventKey={'new'}
              title={intl.formatMessage({ id: 'new_task_title' })}
            >
              <div className={'small text-muted'}>
                {intl.formatMessage({ id: 'new_task_description' })}
              </div>
              <NewTaskForm
                feedbackChain={feedbackChain}
                onCancel={this.props.handleTasksCancel}
              />
            </Tab>
            <Tab
              eventKey={'existing'}
              title={intl.formatMessage({ id: 'existing_task_title' })}
            >
              <div className={'small text-muted'}>
                {intl.formatMessage({ id: 'existing_task_description' })}
              </div>
              <ExistingTaskForm feedbackChain={feedbackChain} />
            </Tab>
          </Tabs>
        </div>
      );
    } else {
      collapseChild = (
        <React.Fragment>
          <div className="small text-muted">
            {intl.formatMessage({ id: 'select_value_proposition_warning' })}
            <hr />
          </div>
          <ValuePropositionToolbar feedbackChain={feedbackChain} />
        </React.Fragment>
      );
    }

    return <Collapse in={this.props.showCollapse}>{collapseChild}</Collapse>;
  }
}
